import React, { Component } from 'react';

export default class StepCounter extends Component {
  render() {
    return (
      <div className="Steps-counter">
        <span className="Steps-counter__current-step">{this.props.currentStep}</span> / <span className="Steps-counter__total-steps">{this.props.totalSteps}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/StepCounter.js